import * as React from 'react';
import classNames from 'classnames';
import { compose } from 'redux';
import withStyles, { WithStyles } from 'react-jss';

import './styles.scss';
import RenderHTML from '../../../../Components/RenderHTML';

export interface ISummaryProduct {
    /** Product name */
    name: string;
    /** Amount of products in the cart */
    amount: number;
    /** Sum of products */
    sum: string;
    /** Sum addOn */
    sumAddOn?: React.ReactNode;
    /** Optional description */
    description?: React.ReactNode;
}

export interface ISummaryMeta {
    /** Label to display */
    label: string;
    /** Sum to display */
    sum: string;
    /** Is total number */
    total?: boolean;
}

export interface ISummaryProps {
    /** List of products */
    products?: ISummaryProduct[];
    /** List of metadatas */
    meta?: ISummaryMeta[];
    /** Title to display */
    title?: string;
    /** Additional content to display */
    extra?: React.ReactNode;
}

interface IState {

}

type Props = ISummaryProps & WithStyles<typeof styles>;

/**
 * Basic list element with hover background. You should wrap this inside ListBasic component.
 */
class Summary extends React.Component<Props, IState> {
    static displayName: string = 'Summary';

    render () {
        return (
            <div className={classNames('summary')}>
                {this.props.title && (
                    <h2 className={classNames('summary-title', this.props.classes.title)}>{this.props.title}</h2>
                )}
                {this.props.products && !!this.props.products.length && (
                    <ul className="summary-list">
                        {this.props.products.map((product, index) => {
                            return (
                                <li key={index} className={classNames('summary-list-item', this.props.classes.item)}>
                                    <div className="name">{product.name}</div>
                                    {product.description && (
                                        <div className="description">{product.description}</div>
                                    )}
                                    <div className="meta">
                                        <div className="amount">{product.amount}x</div>
                                        {product.sumAddOn && (
                                            <div className="addon">{product.sumAddOn}</div>
                                        )}
                                        <div className="sum">
                                            <RenderHTML
                                                nowrapper={true}
                                                html={product.sum}
                                            />
                                        </div>
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                )}
                {this.props.meta && !!this.props.meta.length && (
                    <div className={classNames('summary-totals', this.props.classes.totals)}>
                        {this.props.meta.map((row, index) => {
                            return (
                                <div
                                    className={classNames('row', { grandtotal: row.total, })}
                                    key={index}
                                >
                                    <div className="label">{row.label}</div>
                                    <div className={classNames('value', row.total ? this.props.classes.totalsum : '')}>
                                        <RenderHTML
                                            nowrapper={true}
                                            html={row.sum}
                                        />
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
                {this.props.extra && (
                    <div className={classNames('summary-extra', this.props.classes.extra)}>
                        {this.props.extra}
                    </div>
                )}
            </div>
        );
    }
}

const styles = (theme) => {
    return {
        item: {
            'backgroundColor': theme.colors.gray.lighter,
            '&:nth-child(odd)': {
                backgroundColor: theme.colors.gray.lightest,
            },
            '& .discount': {
                color: theme.colors.sum,
            },
        },
        title: {
            backgroundColor: theme.colors.gray.lighter,
        },
        totals: {
            backgroundColor: theme.colors.gray.light,
        },
        extra: {
            backgroundColor: theme.colors.gray.light,
        },
        totalsum: {
            color: theme.colors.sum,
        },
    };
};

export default compose<React.ComponentClass<ISummaryProps>>(
    withStyles(styles, { injectTheme: true })
)(Summary);
